import { render, staticRenderFns } from "./WarrantyService.vue?vue&type=template&id=ca5a6a1c"
import script from "./WarrantyService.vue?vue&type=script&lang=js"
export * from "./WarrantyService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports